export default "__VITE_ASSET__cb065218__"